import { Type } from 'class-transformer';
import { SystemConfigKey } from './system-config-key.enum';
import { SystemConfigValueDto } from './system-config-value-dto.class';

export class SystemConfig {
	key: SystemConfigKey;

	@Type(() => SystemConfigValueDto)
	value: SystemConfigValueDto;
}
